import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Globals } from '../helpers';
import { HttpInterceptor } from './http-error.interceptor';

@Injectable()
export class AnalyticService {
  private url: string;

  constructor(private http: HttpInterceptor, private globals: Globals) {
    this.url = globals.url + 'analytics/';
  }

  public getAll(body?) {
    return this.http.post(this.url, body).map((response: Response) => response.json());
  }

  public getRawAnalytics(body?) {
    return this.http.post(this.url + 'raw', body).map((response: Response) => response.json());
  }

  public getByDevice(deviceId: string, body?) {
    return this.http.post(this.url, { deviceId, ...body }).map((response: Response) => response.json());
  }
  public getProxyStatistics(filters?) {
    return this.http.post(this.url + 'proxy-statistics', filters).map((response: Response) => response.json());
  }
  public getProxyStatisticsByDevice(deviceId: string, body?) {
    return this.http.post(this.url + 'proxy-statistics', { deviceId, ...body }).map((response: Response) => response.json());
  }
  public getProxyStatisticsByGroup(groupId: string, body?) {
    return this.http.post(this.url + 'proxy-statistics', { groupId, ...body }).map((response: Response) => response.json());
  }
  public getDailyConnections(body = {}) {
    return this.http.post(this.url + 'daily-connections', body).map((response: Response) => response.json());
  }
}
